import { __assign, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import withStyles from '@mui/styles/withStyles';
import clsx from 'clsx';
export var styles = function (theme) { return ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        margin: 'auto',
        justifyContent: 'center',
        alignItems: 'center',
        borderColor: theme.palette.primary.main,
    },
    ring: {
        width: convertSize('md'),
        height: convertSize('md'),
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: 'inherit',
        borderRadius: '100%',
        margin: '0 5px',
        transform: 'scale(0)',
        animation: '$bw-ring-pulse 1000ms ease infinite 0ms',
        '&:nth-child(2)': {
            animationDelay: '300ms',
        },
        '&:nth-child(3)': {
            animationDelay: '600ms',
        },
    },
    '@keyframes bw-ring-pulse': {
        '0%': {
            transform: 'scale(0)',
        },
        '50%': {
            transform: 'scale(1)',
            opacity: 1,
        },
        '100%': {
            opacity: 0,
        },
    },
    inputAdornment: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
    },
}); };
var convertSize = function (size) {
    return ({ sm: 16, md: 20, lg: 48 }[size] || size);
};
/**
 * A basic loading progress indicator with three animated dots.
 * Use the 'inputAdornment' variant if you're using this as a start or end
 * adornment on an Input so it will center itself within the input area.
 * @public
 */
var Loader = forwardRef(function (_a, ref) {
    var classes = _a.classes, className = _a.className, _b = _a.size, size = _b === void 0 ? 'md' : _b, _c = _a.variant, variant = _c === void 0 ? 'default' : _c, restProps = __rest(_a, ["classes", "className", "size", "variant"]);
    var ringStyles = useMemo(function () { return ({
        width: convertSize(size),
        height: convertSize(size),
    }); }, [size]);
    return (React.createElement("div", __assign({ ref: ref, className: clsx(classes === null || classes === void 0 ? void 0 : classes.root, variant === 'inputAdornment' && (classes === null || classes === void 0 ? void 0 : classes.inputAdornment), className), role: "progressbar" }, restProps),
        React.createElement("div", { className: clsx(classes === null || classes === void 0 ? void 0 : classes.ring), style: ringStyles }),
        React.createElement("div", { className: clsx(classes === null || classes === void 0 ? void 0 : classes.ring), style: ringStyles }),
        React.createElement("div", { className: clsx(classes === null || classes === void 0 ? void 0 : classes.ring), style: ringStyles })));
});
export default withStyles(styles, { name: 'BwLoader' })(Loader);
/** @private @internal for docs only! */
export var DocsLoader = function (props) { return React.createElement(Loader, __assign({}, props)); };
//# sourceMappingURL=Loader.js.map